export default __webpack_public_path__ + "static/media/lc-logo.140a2b11.png";